import React from 'react';
import { useNavigate } from 'react-router-dom';
import RecentSignups from '../../../components/dashboard/RecentSignups';
import RecentDemos from '../../../components/dashboard/RecentDemos';
import { useSupportTicketCount } from '../../../components/dashboard/widgets/useSupportTicketCount';
import { ADMIN_PATHS, adminPath } from '../../../constants/adminPaths';
import '../../../components/dashboard/styles/cards.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const { count: openCount, loading: loadingOpen } = useSupportTicketCount('open');

  return (
    <div className="admin-page">
      <div className="dash-grid">
        <div
          className="dash-card"
          role="button"
          tabIndex={0}
          onClick={() => navigate(adminPath(ADMIN_PATHS.SUPPORT))}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') navigate(adminPath(ADMIN_PATHS.SUPPORT));
          }}
          style={{ cursor: 'pointer' }}
        >
          <div className="dash-card__header" style={{ marginBottom: 8 }}>
            <h3 className="dash-card__title">Support Tickets</h3>
          </div>
          <div className="dash-kpis">
            <div className="dash-kpi" style={{ width: '100%' }}>
              <div className="dash-kpi-label">Open</div>
              <div className="dash-kpi-value">{loadingOpen ? '—' : (openCount ?? 0)}</div>
            </div>
          </div>
        </div>
        <div className="dash-card">
          <RecentSignups />
        </div>
        <div className="dash-card">
          <RecentDemos />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
